export function calculateMidPoint(
  positions: [number, number][]
): [number, number] | undefined {
  return [-21.425554, -50.081166];
  //TODO: remover retorno quando existirem mais usinas no banco
  if (positions.length === 0) {
    return [-13.646857512457172, -53.54377569049281];
  }
  const coordinates = positions.map((position) => {
    return {
      lat: position[0],
      long: position[1],
    };
  });
  const sumLat = coordinates.reduce((sum, coord) => sum + coord.lat, 0);
  const sumLong = coordinates.reduce((sum, coord) => sum + coord.long, 0);

  const averageLat = sumLat / coordinates.length;
  const averageLong = sumLong / coordinates.length;

  return [averageLat, averageLong];
}
